import { Badge } from '@/components/ui/badge';

import { useOfferingCategories } from '@/data/offeringCategory';

const OfferingCategoryBadge = ({ offeringCategoryId }) => {
  const offeringCategories = useOfferingCategories();

  if (!offeringCategories.data) {
    return null;
  }

  const offeringCategory = offeringCategories.data.find(
    (category) => category.id === offeringCategoryId
  );

  return <Badge variant="outline">{offeringCategory.label}</Badge>;
};

export default OfferingCategoryBadge;
